var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"newDesBox"},[_c('div',{staticClass:"banner"}),_c('div',{staticClass:"titleList flexBox"}),_c('div',{staticClass:"desBox"},[_c('div',{staticClass:"txt ql-editor",staticStyle:{"white-space":"pre-wrap"},domProps:{"innerHTML":_vm._s(_vm.des.content)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }